/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_Uri_LabelInputs */



/**
* | output |
* | --- |
* | "Or paste this URL into your authenticator app:" |
*
* @param {Profile_Security_Totp_Uri_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_uri_label = /** @type {((inputs?: Profile_Security_Totp_Uri_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_Uri_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Oder füge diese URL in deine Authenticator-App ein:")
	return /** @type {LocalizedString} */ ("Or paste this URL into your authenticator app:")
});